export enum ErrorCode {
  EntityNotFound = 'EntityNotFound',
  RowIndexOutOfBounds = 'RowIndexOutOfBounds',
  BayIndexOutOfBounds = 'BayIndexOutOfBounds',
  SpaceOccupied = 'SpaceOccupied',
  ExceedingMaxBay = 'ExceedingMaxBay',
  ExceedingMaxRow = 'ExceedingMaxRow',
  ExceedingMaxTier = 'ExceedingMaxTier',
  ValidationError = 'ValidationError',
  NameNotUnique = 'NameNotUnique',
  ImdgStackingOnTopViolation = 'ImdgStackingOnTopViolation',
  ImdgTierCapViolation = 'ImdgTierCapViolation',
  ImdgSegregationViolation = 'ImdgSegregationViolation',
}
